import { Store } from 'react-notifications-component';

class Util {
  static showNotification = (title, message, type, onRemoval, duration) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: 'top',
      container: 'top-right',
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: { duration: duration || 5000, onScreen: true },
      onRemoval: onRemoval !== undefined ? onRemoval : () => {}
    });
  }
}
export default Util;